import { useIntl } from "react-intl";
import { Colors } from "../../constants";
import { handleFormikValueChange } from "../../utils";
import Clickable from "../Clickable";
import Icon from "../Icon";
import StatusPill from "../StatusPill";
import { SpecificationItem } from "./types/specificationTypes";

type SpecificationVisibilityToggle = {
  readonly values: {
    specifications: SpecificationItem[];
  };
  readonly objIdx: number;
  readonly "data-testid"?: string;
};

function SpecificationVisibilityToggle(props: SpecificationVisibilityToggle) {
  const specification = props.values.specifications[props.objIdx];
  const isVisible = specification.uiVisible;
  const intl = useIntl();
  return (
    <div className="dfa-visibility-label" data-testid={props["data-testid"]}>
      <Clickable
        onClick={() => {
          handleFormikValueChange(props, !specification.uiVisible);
        }}
      >
        <Icon
          name={isVisible ? "icon3-eh-show-details" : "icon3-eh-hide-details"}
        />
        <StatusPill
          backgroundColor={
            isVisible ? Colors.EH_CYAN_90 : Colors.EH_NEUTRAL_GRAY
          }
          contentText={intl.formatMessage({
            id: isVisible ? `specifications.visible` : `specifications.hidden`,
          })}
        />
      </Clickable>
    </div>
  );
}

export default SpecificationVisibilityToggle;
